import { createSelector } from 'reselect';
import { TicketTypeEnum } from 'common/enums/ZendeskEnum';

const editPlanApprovalFormData = {
    subject: { value: '', fieldId: 'subject', label: 'Subject' },
    message: { value: '', fieldId: 'message', label: 'Message' },
    name: { value: '', fieldId: 'name', label: 'Name' },
    email: { value: '', fieldId: 'email', label: 'E–mail ID' },
    team: { value: '', fieldId: 'team', label: 'Team' },
    url: { value: '', fieldId: 'url', label: 'Plan Link' }
};

const helpAndSupportFormData = {
    name: { value: '', fieldId: 'name', label: 'Name' },
    email: { value: '', fieldId: 'email', label: 'E–mail ID' },
    ccEmails: { value: '', fieldId: 'ccEmails', label: 'CC' },
    phone: { value: '', fieldId: 'phone', label: 'Contact Number' },
    subject: { value: '', fieldId: 'subject', label: 'Subject' },
    url: { value: '', fieldId: 'url', label: 'URL' },
    message: { value: '', fieldId: 'message', label: 'Message' },
    attachments: {
        value: {
            files: []
        },
        fieldId: 'attachments',
        label: 'Attachments'
    }
};

export const getFormData = createSelector(
    [
        (state, props) => props,
        (state, props, { isEditOrViewPlanScreen }) => isEditOrViewPlanScreen, //for initial load
        (state, props, { teamName }) => teamName //for initial load
    ],
    (props, isEditOrViewPlanScreen, teamName) => {
        if (!props.personnel) {
            return helpAndSupportFormData;
        }
        const { personnel, ticketType, extraTicketItems } = props;

        switch (ticketType) {
            case TicketTypeEnum.EditPlanApproval: {
                const name = personnel.get('name') || '';
                const email = personnel.get('email') || '';
                const planLink = isEditOrViewPlanScreen
                    ? window.location.href
                    : '';
                const extraItems = {};
                extraTicketItems &&
                    extraTicketItems.forEach(ticketItem => {
                        extraItems[ticketItem.fieldId] = {
                            value: '',
                            fieldId: ticketItem.fieldId,
                            label: ticketItem.item
                        };
                    });

                const fields = {
                    ...editPlanApprovalFormData,
                    ...extraItems,
                    name: { ...editPlanApprovalFormData.name, value: name },
                    email: { ...editPlanApprovalFormData.email, value: email },
                    url: { ...editPlanApprovalFormData.url, value: planLink },
                    team: {
                        ...editPlanApprovalFormData.team,
                        value: teamName || ''
                    }
                };

                // Removing duplicate team field from fields if we have team field in custom fields
                for (const key in extraItems) {
                    const item = extraItems[key];
                    if (
                        item.label &&
                        item.label.toLowerCase().includes('team')
                    ) {
                        fields[key] = {
                            ...fields[key],
                            value: teamName || ''
                        };

                        if (fields.team) {
                            delete fields.team;
                        }
                    }
                }

                return fields;
            }
            case TicketTypeEnum.HelpAndSupport: {
                const name = personnel.get('name') || '';
                const email = personnel.get('email') || '';
                const phone = personnel.get('phone') || '';
                return {
                    ...helpAndSupportFormData,
                    name: { ...helpAndSupportFormData.name, value: name },
                    email: { ...helpAndSupportFormData.email, value: email },
                    phone: { ...helpAndSupportFormData.phone, value: phone }
                };
            }
        }
    }
);
